export default __webpack_public_path__ + "static/media/i_bstop_silver.cd6bea0e.svg";